import * as React from "react";
import FilterImage from '../../../../assets/icons/filter.svg'
import ChevronRightBlack from '../../../../assets/icons/ChevronRightBlack.svg'
import classes from './Filter.module.scss'
import { PriceSlider } from "../../../../components/PriceSlider/PriceSlider";

export const Filter = ({ defaultFilters, filters, setFilters }) => {

    const onAfterChange = (value, index) => {
        handleFilterChange('price', { min: value[0], max: value[1] });
    }

    const handleColorClick = (color, isColorSelected) => {

        let finalColors = filters?.colors || [];
        if (isColorSelected) finalColors = finalColors.filter((item) => item !== color)
        else finalColors.push(color);

        handleFilterChange("colors", finalColors)
    }
    const handleSizeClick = (size, isSizeSelected) => {

        let finalSize = filters?.size || [];
        if (isSizeSelected) finalSize = finalSize.filter((item) => item !== size)
        else finalSize.push(size);

        handleFilterChange("size", finalSize)
    }
    const handleScarfClick = (scarf, isScarfSelected) => {

        let finalScarf = filters?.scarf || [];
        if (isScarfSelected) finalScarf = finalScarf.filter((item) => item !== scarf)
        else finalScarf.push(scarf);

        handleFilterChange("scarf", finalScarf)
    }

    const handleFilterChange = (name, value) => {
        const processedFilters = { ...filters };
        processedFilters[name] = value;
        console.log(processedFilters)
        setFilters(processedFilters);
    };

    return (
        <div className={classes.FilterContainer}>
            <div className={classes.FilterHeader}>PRICE (AED)</div>
            <div className={classes.PriceContainer}>
                <div className={classes.SliderContainer} >
                    <PriceSlider
                        min={defaultFilters?.price?.min}
                        max={defaultFilters?.price?.max}
                        value={[filters?.price?.min, filters?.price?.max]}
                        onAfterChange={onAfterChange}
                    />
                </div>
                <div className={classes.SliderContainerPrices}>
                    <div>{filters?.price?.min} د.إ </div>
                    <div>{filters?.price?.max} د.إ </div>
                </div>

            </div>
            <div className={classes.FilterHeader}>COLOR</div>
            <div className={classes.ColorContainer}>
                {defaultFilters.colors.map((color) => {
                    const isColorActive = Boolean(filters.colors.find((activeColor) => activeColor === color));
                    return (
                        <div
                            className={`${classes.ColorBoxContainer} ${isColorActive ? classes.ColorBoxContainerActive : ''}`}
                            onClick={() => handleColorClick(color, isColorActive)}
                        >
                            <div style={{ backgroundColor: color }} className={classes.ColorBox}></div>
                        </div>
                    )
                })}
            </div>
            <div className={classes.FilterHeader}>SIZES</div>
            <div className={classes.SizeContainer}>
                {defaultFilters.size.map((size, index) => {
                    const isSizeActive = Boolean(filters.size.find((activeSize) => activeSize === size));
                    return (
                        <div className={classes.sizeCheckBox}>
                            <input type="checkbox" id={index} name={size} checked={isSizeActive} onChange={(e) => handleSizeClick(size, e.target.checked)} value={size} />
                            <div>{size}</div>
                        </div>
                    )
                })}
            </div>


        </div>
    );

    //     <div className={classes.div5}>

    //     {defaultFilters.categories.map((category, index) => {
    //         return (
    //             <div className={classes.div7} key={index}>
    //                 <div className={classes.div8}>{category}</div>
    //                 <img
    //                     alt="test"
    //                     src={ChevronRightBlack}
    //                     className="img-3"
    //                 />
    //             </div>
    //         )
    //     })}
    // </div>
}




